import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractMediator from "../../../core/ui/AbstractMediator";

export default class GameSavedNoticeMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);

        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this._target.alpha = 0;

        this._target.textField.text = this._languagePack.getText(`saving.gameSavedNotice`);
    }

    show(delay = 0, animate = true) {
        return new Promise(resolve => {
            if (animate) {
                createjs.Tween.get(this._target)
                    .wait(delay)
                    .to({ alpha: 1 }, 450, createjs.Ease.sineInOut)
                    .call(() => {
                        resolve();
                    });
            } else {
                if (delay === 0) {
                    this._target.alpha = 1;
                    resolve();
                } else {
                    setTimeout(() => {
                        this._target.alpha = 1;
                        resolve();
                    }, delay);
                }
            }
        })
    }

    hide(delay = 0, animate = true) {
        return new Promise(resolve => {
            if (animate) {
                createjs.Tween.get(this._target)
                    .wait(delay)
                    .to({ alpha: 0 }, 450, createjs.Ease.sineInOut)
                    .call(() => {
                        resolve();
                    });
            } else {
                if (delay === 0) {
                    this._target.alpha = 0;
                    resolve();
                } else {
                    setTimeout(() => {
                        this._target.alpha = 0;
                        resolve();
                    }, delay);
                }
            }
        })
    }
}